import varAxios from "../../../Comman/axios";
import { 
         deleteHeartRunnerUrl,
         enabledisableHeartRunnerUrl,
         
         updateHeartRunnerSAPasswordUrl,
         updateHeartRunnerSuperAdminUrl,
         getHeartRunnerListUrl,
         getHeartRunnerOrg,
         UpdateHeartRunnerDistanceUrl,  
         resetUserDeviceKeyUrl,
         userLogoutUrl,
         RemoveProfilePictureUrl,
         GetRegionListUrl,
         GetRolePermissionList
        }from "../../../Comman/apiEndPoints"

export const FETCH_HEARTRUNNER_LIST_REQUEST = "(fetch) FETCH HEARTRUNNER LIST REQUEST";
export const FETCH_HEARTRUNNER_LIST_SUCCESS = "(fetch) FETCH HEARTRUNNER  LIST SUCCESS";
export const FETCH_HEARTRUNNER_LIST_ERROR = "(fetch) FETCH  HEARTRUNNER  LIST ERROR";

export const FETCH_HEARTRUNNER_ORG_REQUEST = "(registration) FETCH HEARTRUNNER ORG REQUEST";
export const FETCH_HEARTRUNNER_ORG_SUCCESS = "(registration) FETCH HEARTRUNNER ORG SUCCESS";
export const FETCH_HEARTRUNNER_ORG_ERROR = "(registration) FETCH HEARTRUNNER ORG ERROR";

export const UPDATE_HEARTRUNNER_LIST_REQUEST = "(update) UPDATE HEARTRUNNER DETAILS REQUEST";
export const UPDATE_HEARTRUNNER_LIST_SUCCESS = "(update) UPDATE HEARTRUNNER DETAILS SUCCESS";
export const UPDATE_HEARTRUNNER_LIST_ERROR = "(update) UPDATE HEARTRUNNER DETAILS ERROR";

export const UPDATE_PASSWORD_REQUEST = "(update) UPDATE PASSWORD REQUEST";
export const UPDATE_PASSWORD_SUCCESS = "(update) UPDATE PASSWORD SUCCESS";
export const UPDATE_PASSWORD_ERROR = "(update) UPDATE PASSWORD ERROR";

export const UPDATE_DEVICE_DETAILS_REQUEST = "(update) UPDATE DEVICE DETAILS REQUEST";
export const UPDATE_DEVICE_DETAILS_SUCCESS = "(update) UPDATE DEVICE DETAILS SUCCESS";
export const UPDATE_DEVICE_DETAILS_ERROR = "(update) UPDATE DEVICE DETAILS ERROR";
export const Logout_User_Success = "Logout_User_Success";
export const Fetch_All_Region_Data1 = "Fetch_All_Region_Data1";
export const FETCH_PERMISSIONS_LIST_DATA = "FETCH_PERMISSIONS_LIST_DATA";

export function fetchHeartRunnerDetail(RegionId, dispatch) {
    let data = {
        RegionId: RegionId
    }

    return (dispatch) => {
        dispatch(fetchHeartRunnerDetailRequest(true));

        return varAxios.post(getHeartRunnerListUrl,RegionId,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
            .then((response) => {
                dispatch(
                    fetchHeartRunnerDetailSuccess(false, response.data.List,response.data.statusCode)
                );
            })
            .catch((error) => {
                if(error.response.data.statusCode==401){
                    
                    dispatch(
                        fetchHeartRunnerDetail(RegionId, dispatch)
                    );
                }
            })
    }
}
/* export function fetchHeartRunnerDetail(OrganizationId, dispatch) {
    let data = {
        OrganizationId: OrganizationId
    }

    return (dispatch) => {
        dispatch(fetchHeartRunnerDetailRequest(true));

        return varAxios.get(getHeartRunnerListUrl,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
            .then((response) => {
                dispatch(
                    fetchHeartRunnerDetailSuccess(false, response.data.List,response.data.statusCode)
                );
            })
            .catch((error) => {
                if(error.response.data.statusCode==401){
                    
                    dispatch(
                        fetchHeartRunnerDetail(OrganizationId, dispatch)
                    );
                }
            })
    }
} */

export function fetchHeartRunnerDetailRequest(isLoading) {
    return {
        type: FETCH_HEARTRUNNER_LIST_REQUEST,
        isLoading
    }
}

export function fetchHeartRunnerDetailSuccess(isLoading, heartRunnerList,statusCode) {
    return {
        type: FETCH_HEARTRUNNER_LIST_SUCCESS,
        isLoading,
        heartRunnerList,
        statusCode
    }
}

export function deleteHeartRunnerDetail(isLoading, heartRunnerList,RegionId, dispatch) {
    var deleteheartRunnerList = [];
    deleteheartRunnerList = heartRunnerList;
    

    return (dispatch) => {
        dispatch(updateHeartRunnerDetailRequest(true));

        return varAxios.delete(deleteHeartRunnerUrl,{data:deleteheartRunnerList} ,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
            .then((response) => {
               /*  dispatch(
                    updateHeartRunnerDetailSuccess(false, 
                        response.data.heartRunnerUserList, 
                        response.data.errorMessage,
                        response.data.statusCode
                    )
                ); */
                this.fetchHeartRunnerDetail({RegionId:RegionId})
            })
            .catch((error) => {
                if(error.response.data.statusCode==401){
                    
                    dispatch(
                        deleteHeartRunnerDetail(isLoading, heartRunnerList, dispatch)
                    );
                }
            })
    }
}

export function disableHeartRunnerDetail(isLoading, data, dispatch) {
    

    return (dispatch) => {
        dispatch(updateHeartRunnerDetailRequest(true));

        return varAxios.post(enabledisableHeartRunnerUrl, data,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
            .then((response) => {
                dispatch(
                    updateHeartRunnerDetailSuccess(false, 
                        response.data.heartRunnerUserList, 
                        response.data.errorMessage,
                        response.data.statusCode
                    )
                );
            })
            .catch((error) => {
                if(error.response.data.statusCode==401){
                    
                    dispatch(
                        disableHeartRunnerDetail(isLoading, data, dispatch)
                    );
                }
            })
    }
}
export function enableHeartRunnerDetail(isLoading, data, dispatch) {
    var disableHeartRunnerList = [];
    disableHeartRunnerList = data;

    return (dispatch) => {
        dispatch(updateHeartRunnerDetailRequest(true));

        return varAxios.post(enabledisableHeartRunnerUrl, disableHeartRunnerList,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
            .then((response) => {
                dispatch(
                    updateHeartRunnerDetailSuccess(false, 
                        response.data.heartRunnerUserList, 
                        response.data.errorMessage,
                        response.data.statusCode
                    )
                );
            })
            .catch((error) => {
                
                if(error.response.data.statusCode==401){
                    
                    dispatch(
                        enableHeartRunnerDetail(isLoading, data, dispatch)
                    );
                }
            })
    }
}


export function updateHeartRunnerDetailRequest(isLoading) {
    return {
        type: UPDATE_HEARTRUNNER_LIST_REQUEST,
        isLoading
    }
}

export function updateHeartRunnerDetailSuccess(isLoading, heartRunnerList, messageLabel,statusCode) {
    return {
        type: UPDATE_HEARTRUNNER_LIST_SUCCESS,
        isLoading,
        heartRunnerList,
        messageLabel,
        statusCode
    }
}

export function removeProfilePic(formDat,RegionId) {     
    return (dispatch) => {
        dispatch(updateViewDetailsRequest(true,''));
        return varAxios.post(RemoveProfilePictureUrl, formDat,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
            .then((response) => { 
                
                /* dispatch(
                    updateHeartRunnerDetailSuccess(false, 
                            response.data.userList,
                            response.data.Message,
                            response.data.statusCode,

                        )
                ); */
                this.fetchHeartRunnerDetail({RegionId:RegionId})
            })
            .catch((error) => {
                console.log(error)
            })
    }
}

export function updateHeartRunnerDetail(formData) {
    return (dispatch) => {
       // dispatch(updateViewDetailsRequest(true,''));
        return varAxios.post(updateHeartRunnerSuperAdminUrl, formData,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
            .then((response) => {
                /* dispatch(
                    updateHeartRunnerDetailSuccess(false, 
                            response.data.heartRunnerUserList,
                            response.data.Message,
                            response.data.statusCode,

                        )
                ); */
                this.fetchHeartRunnerDetail({RegionId:formData.RegionId})
            })
            .catch((error) => {
                console.log(error)
            })
    }
}
export function updateViewDetailsRequest(isLoading,statusCode) {
    return {
        type: UPDATE_HEARTRUNNER_LIST_REQUEST,
        isLoading,
        statusCode

    }
}

export function updatePasswordRequest(isLoading) {
    return {
        type: UPDATE_PASSWORD_REQUEST,
        isLoading
    }
}

export function updatePasswordSuccess(isLoading, HeartRunnerDetails, messageLabel,statusCode) {
    return {
        type: UPDATE_PASSWORD_SUCCESS,
        isLoading,
        HeartRunnerDetails,
        messageLabel,
        statusCode
    }
}

export function updatePasswordDetail(formData,RegionId) {
    return (dispatch) => {
        dispatch(updateViewDetailsRequest(true,''));
        return varAxios.post(updateHeartRunnerSAPasswordUrl, formData,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
            .then((response) => {
             /*    dispatch(
                    updateHeartRunnerDetailSuccess(false, 
                            response.data.heartRunnerUsers,
                            response.data.Message,
                            response.data.statusCode,

                        )
                ); */
                this.fetchHeartRunnerDetail({RegionId:RegionId})
            })
            .catch((error) => {
                console.log(error)
            })
    }
}

export function fetchHeartRunnerOrg(dispatch) {
    return (dispatch) => {
        dispatch(fetchHeartRunnerOrgRequest(true));
        return varAxios.get(getHeartRunnerOrg, 
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
            .then((response) => {
                dispatch(
                    fetchHeartRunnerOrgSuccess(
                        response.data,
                        false,
                    ));
            })
            .catch((error) => {
                dispatch(
                    fetchHeartRunnerOrgSuccess(
                        error.response.data,
                        false,
                    ));
                
            })
    }
}

export function fetchHeartRunnerOrgRequest(data,isLoading) {
    return {
        type: FETCH_HEARTRUNNER_ORG_REQUEST,
        data,
        isLoading
    }
}

export function fetchHeartRunnerOrgSuccess(heartRunnerOrgInfo,isLoading) {
    
    return {
        type: FETCH_HEARTRUNNER_ORG_SUCCESS,
        heartRunnerOrgInfo,
        isLoading
    }
}

export function updateAlarmSettings(formData,RegionId) {
   
    
    return (dispatch) => {
        dispatch(updateViewDetailsRequest(true));

        return varAxios.post(UpdateHeartRunnerDistanceUrl, formData,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
            .then((response) => {
              /*   dispatch(
                    updateHeartRunnerDetailSuccess(false,
                     response.data.heartRunnerUsers,   
                     response.data.errorMessage,
                     response.data.statusCode,
                     response.data.errorCode,
                    )
                ); */
                  this.fetchHeartRunnerDetail({RegionId:RegionId})
            })
            .catch((error) => {
                if(error.response.data.statusCode==401){
                    
                    dispatch(
                        updateAlarmSettings(formData, dispatch)
                    );
                }
            })
    }
}

export function resetDeviceKey(isLoading, data, dispatch) {  
    return (dispatch) => {
        dispatch(updateDeviceDetailRequest(true));

        return varAxios.post(resetUserDeviceKeyUrl, data,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
            .then((response) => {
                dispatch(
                    updateDeviceDetailSuccess(false, response.data.errorMessage,response.data.statusCode)
                );
            })
            .catch((error) => {
            })
    }
}


export function updateDeviceDetailRequest(isLoading) {
    return {
        type: UPDATE_DEVICE_DETAILS_REQUEST,
        isLoading
    }
}

export function updateDeviceDetailSuccess(isLoading, messageLabel,statusCode) {
    return {
        type: UPDATE_DEVICE_DETAILS_SUCCESS,
        isLoading, 
        messageLabel,
        statusCode
    }
}
export function userLogout(id,Region) {    
    return (dispatch) => {
        dispatch(updateHeartRunnerDetailRequest(true));
        return varAxios.post(userLogoutUrl, id,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
            .then((response) => {
                dispatch(
                    LogoutUserSuccess( 
                        response.data.Message, 
                        response.data.errorCode,
                        response.data.statusCode
                    )
                );
                 this.fetchHeartRunnerDetail({RegionId:Region})
            })
            .catch((error) => {
            dispatch(updateHeartRunnerDetailRequest(false));
            })
    }

}
export function getAllRegionSettings() {
     let requestPayload={
    UserId:sessionStorage.getItem('SuperAdminUserID')
  }
    return(dispatch) =>{
       return varAxios.post(GetRegionListUrl,requestPayload,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
       .then(response => {
       
       
        this.fetchHeartRunnerDetail({RegionId:response.data.regionList[0].ID})
          dispatch(
            fetchAllRegionData({
              errorCode : response.data.errorCode,
              statusCode : response.data.statusCode,
              regionList : response.data.regionList
             }));
       })
       .catch((error) => {
          console.log("error",error);
      })
    }
}
export function fetchAllRegionData({errorCode, statusCode, regionList}) {
  return {
    type : Fetch_All_Region_Data1,
    errorCode,
    statusCode,
    regionList
  }
  
}
export function LogoutUserSuccess(message,errorCode,statusCode){
    return{
        type : Logout_User_Success,
        message,
        errorCode,
        statusCode
    }
}
export function getPermissionsListFunc() {
    return(dispatch) => {
        
       return varAxios.get(GetRolePermissionList)
       .then(response => {
        
           if(response.data.statusCode == 200){
           
            dispatch(
                fetchPermissionsListData(response.data.permissionList)
                );
           }
       })
       .catch((error) => {
          console.log("error",error);
      })
    }
}
export function fetchPermissionsListData(list) {
    return {
        type: FETCH_PERMISSIONS_LIST_DATA,
        list
    }
}